import subProcessorsSource from '../../content/legal/sub-processors.md?raw';
import { LegalLayout } from './LegalLayout';

export default function SubProcessors() {
  return <LegalLayout source={subProcessorsSource} />;
}
